<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'LianDongZhiHui',
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.layout_wraper {
  position: relative;
}
</style>
